document.addEventListener('DOMContentLoaded', function() {
  
  // ====================================================================
  // 1. XỬ LÝ VIDEO Ở PHẦN MÔ TẢ / PAGE BUILDER (Bằng cảm biến trượt)
  // ====================================================================
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.play().catch(() => {});
      } else {
        entry.target.pause();
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('video[autoplay]').forEach(video => {
    videoObserver.observe(video);
  });

  // Video ở khung ảnh chính (gallery sản phẩm) do media-gallery.js điều khiển

});